import { BASE_LIGHT_THEME_PALETTE } from 'owa-theme-common';
import { DefaultPalette, type IPalette } from '@fluentui/style-utilities';
import type { OwaPalette } from 'owa-theme-shared';

export function createCssVariablesPalette<TKeys extends string>(
    paletteKeys: readonly TKeys[]
): Record<TKeys, string> {
    const variablePalette = Object.fromEntries(
        paletteKeys.map(key => [key, `var(--${key})`] as const)
    ) as Record<TKeys, string>;

    return variablePalette;
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createCssVariablesPalette called at module scope is not allowed. This may cause unwanted side effects. */
const cssVariablePalette: IPalette & OwaPalette = createCssVariablesPalette([
    ...Object.keys(DefaultPalette),
    ...Object.keys(BASE_LIGHT_THEME_PALETTE),
] as const) as IPalette & OwaPalette;

export default function getPalette(): typeof cssVariablePalette {
    return cssVariablePalette;
}
